import React, { Component } from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { required } from '../../util/validationFunctions'
import InputText from '../comun/form/InputText'
import InputCheckBox from '../comun/form/InputCheckBox'
import InputSelect from 'react-select'
import InputNumerical from '../comun/form/InputNumerical'
import InputTextArea from '../comun/form/InputTextArea'
import Dropzone from 'react-dropzone'
import { Unarchive } from '@material-ui/icons'
import './ImportarDireccionesExcel.scss'

class ImportarDireccionesExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      archivos: '',
      archivoCargado: false
    }
  }

  onDrop (archivos) {
    archivos.map((archivo, i) => {
      var reader = new FileReader();
      reader.onloadend = () => {
        archivo.content=reader.result
        this.props.actions.subirArchivosImportarDireccionesExcel({name: archivo.name, file: reader.result})
        this.setState({archivos: {name: archivo.name, file: reader.result}})
        this.setState({archivoCargado: true})
      }
      reader.readAsDataURL(archivo)
    })
  }

  submitImportarDireccionesExcel () {
    this.props.actions.submitImportarDireccionesExcel(this.state.archivos)
    this.setState({archivoCargado: false})
  }

  cerrarModalImportarDireccionesExcel () {
    this.props.actions.cerrarModalImportarDireccionesExcel()
    this.setState({archivos: ''})
    this.setState({archivoCargado: false})
  }

  descargarPlantillaExcelDireccionesExcel () {
    this.props.actions.descargarPlantillaExcelDireccionesExcel()
  }

  render () {
    const {
      t, handleSubmit, showModalImportarDireccionesExcel, archivoExcel, listImportarDireccionesExcel
      } = this.props

    if(!showModalImportarDireccionesExcel) return null

    let errorImportar = listImportarDireccionesExcel.filter(item => item.insertado===false)
    return (
      <Modal show={showModalImportarDireccionesExcel} onHide={() => this.cerrarModalImportarDireccionesExcel()} aria-labelledby="contained-modal-title-lg" backdrop="static" className="form-carga-index">
      <form>
        <Modal.Header closeButton>
          <Modal.Title>
          {t('IMPORTAR_DIRECCIONES_EXCEL.TITLE')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <div className="archivos-carga-index">
              <Dropzone
                accept=".xls,.xlsx"
                onDrop={this.onDrop.bind(this)}
                uploadMultiple={true}
                maxFiles={null}
                // maxSize={200000}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}  className="custom-file-label">
                    <input {...getInputProps()} />
                    <label><span className="explorar-input-file">{t('COPIA_SEGURIDAD.SUBIR_ARCHIVO')}</span></label>
                  </div>
                )}
              </Dropzone>
            </div>
            {
              Object.keys(archivoExcel).length > 0 ? (
                <p className="nombre-archivo-subido"><Unarchive />{archivoExcel.name}</p>
              ) : null
            }            
            {
              Object.keys(errorImportar).length > 0 ? (
                <div className="resultado-importar-direcciones error-importar">
                  <ul>
                    <li>{t('IMPORTAR_DIRECCIONES_EXCEL.ERROR')}</li>
                  </ul>
                </div>
              ) : Object.keys(listImportarDireccionesExcel).length > 0 ? (
                <div className="resultado-importar-direcciones">                
                  <ul>                                          
                    <li>{t('IMPORTAR_DIRECCIONES_EXCEL.DOCUMENTO_SUBIDO')}</li>                      
                  </ul>                                      
                </div>
              ) : null
            }
          </Row>
        </Modal.Body>
        <Modal.Footer>          
          <Button type="button" onClick={() => this.descargarPlantillaExcelDireccionesExcel()} className="btn btn-primary">{t('IMPORTAR_DIRECCIONES_EXCEL.DESCARGAR_EJEMPLO_EXCEL')}</Button>
          {
            Object.keys(listImportarDireccionesExcel).length === 0 ? (
              <Button type="button" onClick={() => this.submitImportarDireccionesExcel()} className="btn btn-primary">{t('CARGA_INDEX.ACEPTAR')}</Button>
            ) : null
          }
          <Button type="button" className="btn btn-white" onClick={() => this.cerrarModalImportarDireccionesExcel()}>{t('CARGA_INDEX.CANCELAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ImportarDireccionesExcel',
})(ImportarDireccionesExcel))